import IndicatorButton from 'components/indicator/IndicatorButton';
import { AppConst } from 'constants/appConst';

import type { JSX } from 'react';

export function SignupFooterActions({
  processing,
  errorMessage,
  onSubmit,
  onGoSignIn,
}: {
  processing: boolean;
  errorMessage: string;
  onSubmit: () => void;
  onGoSignIn: () => void;
}): JSX.Element {
  return (
    <>
      <div className="mt-7" style={{ marginTop: '5rem' }}>
        <div className="mt-7 d-flex justify-content-center">
          <a href={AppConst.url.term} target="_blank" rel="noopener noreferrer">
            利用規約
          </a>
        </div>
        <div className="mt-7 d-flex justify-content-center">
          <a href={AppConst.url.privacy} target="_blank" rel="noopener noreferrer">
            プライバシーポリシー
          </a>
        </div>
      </div>
      {/* 登録ボタン */}
      <div className="mt-5">
        <div className="form-footer mb-2">
          {' '}
          <div className="row justify-content-center">
            <div className="col-12 col-md-8 col-lg-6">
              <button
                type="button"
                className="btn btn-common moderate-blue w-100"
                onClick={onSubmit}
                disabled={processing}
              >
                <IndicatorButton visible={processing} />
                利用規約とプライバシーポリシーに同意してはじめる
              </button>
              {errorMessage && (
                <div className="mt-2 text-danger text-center fw-bold">{errorMessage}</div>
              )}
              <div className="mt-3 text-center">
                <div className="d-flex flex-wrap justify-content-center align-items-center gap-2">
                  <p className="m-0 text-nowrap">BranQのアカウントをお持ちですか？</p>
                  <a
                    onClick={onGoSignIn}
                    rel="noopener noreferrer"
                    className="d-flex align-items-center m-0 text-nowrap"
                  >
                    ログインはこちら
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
